<template>
  <div class="chatBox">
    <div class="chat_dom" ref="chat_dom">
      <!-- 聊天对话  -->
      <div v-for="(item, index) in chatData" :key="index" class="chat_list">
        <!-- AI助手左侧 -->
        <div v-if="item.role === 'assistant'" class="left_dom">
          <img src="../../image/robot.png" alt srcset style="width: 33px;height: 33px;" />
          <div class="left_dom_text">
            {{ item.content}}
            <!-- <p style="white-space: pre-wrap;">{{ item.content}}</p> -->
            <!-- <p>{{ item.content}}</p> -->
            <!-- 知识库 -->
            <!-- <div v-if="!item.message.metadata.docs" class="docs"></div>
            <div v-else-if="item.message.metadata.docs.length > 0" class="docs">
              <h2
                style="margin:20px auto 10px;font-weight:600;color:rgba(0, 0, 0, 0.7)"
              >
                参考文献:
                <span
                  class="more"
                  @click="more"
                  v-if="item.message.metadata.docs.length > 1 && !isMore"
                  >查看更多》({{ item.message.metadata.docs.length }})</span
                >
                <span
                  class="more"
                  @click="more"
                  v-if="item.message.metadata.docs.length > 1 && isMore"
                  >折叠({{ item.message.metadata.docs.length }})</span
                >
              </h2>
              <div v-if="!isMore">
                <span
                  @click="docsBtn(item.message.metadata.docs[0])"
                  class="more"
                >
                  {{ item.message.metadata.docs[0].title }}
                </span>
              </div>
              <div v-else>
                <div
                  v-for="(item, index) in item.message.metadata.docs"
                  :key="index"
                >
                  <p @click="docsBtn(item)" class="more">
                    {{ item.title }}
                  </p>
                </div>
              </div>
            </div>-->
          </div>
          <!-- <p class="icon">
            <img
              src="../../image/zan1.png"
              alt=""
              srcset=""
              @click="zanBtn(1, item, index)"
              v-if="!item.message.feedback"
            />
            <img
              src="../../image/zan2.png"
              alt=""
              srcset=""
              @click="zanBtn(2, item, index)"
              v-if="!item.message.feedback"
            />
          </p>-->
        </div>
        <!-- 用户右侧 -->
        <div v-if="item.role === 'user' || item.role === 'doctor'" class="right_dom">
          <div class="right_dom_text">{{ item.content}}</div>
          <img
            style="width: 35px;height: 35px;"
            :src="item.role ==='user'?require('../../image/user.png'):require('../../image/ys.png')"
            alt
            srcset
          />
        </div>
        <div class="clearboth"></div>
        <!-- 用于评价的插槽 -->
        <!-- <slot
          name="append-suggest"
          v-if="
            !item.metadata.rating &&
              item.metadata.rating !== 0 &&
              index > 1 &&
              item.parent === chatData[index - 1].parent
          "
          :suggestprop="{ ...item, activeIndex: index }"
        ></slot>-->
      </div>
    </div>


    <el-dialog
      :title="item.title"
      :visible.sync="visible"
      :close-on-click-modal="true"
      class="dialog"
      width="600px"
    >
      <div>{{ item.content }}</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ChatBox",
  components: {},
  props: {
    tip: {
      type: String
    },
    chatData: {
      type: Array
    }
    /* 默认输入 */
    // textareaDeful: {
    //   type: String
    // }
  },
  watch: {
    // 如果你需要在prop变化时执行特定的逻辑，可以使用watch
    // textareaDeful(newVal, oldVal) {
    //   console.log("Prop changed:", newVal, oldVal);
    //   this.textarea = newVal;
    // }
  },
  data() {
    return {
      isMore: false,
      item: {},
      visible: false
    };
  },
  methods: {
    docsBtn(item) {
      console.log(item);
      this.item = item;
      this.visible = true;
    },
    more() {
      this.isMore = !this.isMore;
    },

    /* 点赞 */
    zanBtn(e, item, index) {
      console.log(e);
      this.$emit("zanBtn", e, item, index);
    }
  }
};
</script>

<style scoped lang="less">
.chatBox {
  width: 100%;
  position: relative;
  font-size: 14px;
  letter-spacing: 0.8px;
  height: 100%;
}

.tip {
  line-height: 20px;
  color: #1a1a1a;
  font-size: 13px;
  margin: 20px;
  display: flex;
  .title {
    display: flex;
    width: 70px;
    height: 20px;
    color: rgb(65, 105, 225);
    align-items: center;
    img {
      display: block;
      width: 15px;
      height: 15px;
      margin-right: 5px;
    }
  }
  p {
    width: 100%;
  }
}

img {
  width: 30px;
  height: 30px;
  display: block;
}
/* 聊天窗口内容部分 */
.chat_dom {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  margin: 0;
}
// .chat_list {
// border: 1px solid rgb(0, 21, 255);
// }
.clearboth {
  clear: both;
}

.right_dom,
.left_dom {
  display: flex;
  margin: 10px;
  max-width: 90%;
  position: relative;
  > div {
    margin: 0 10px;
  }
  .icon {
    width: 100px;
    position: absolute;
    right: -100px;
    bottom: 0;
    display: flex;
    img {
      width: 16px;
      height: 16px;
      margin: 0 5px;
      display: block;
    }
    img:hover {
      cursor: pointer;
    }
  }
}

.right_dom {
  float: right;
}

.left_dom {
  float: left;
}

/* 聊天气泡 - 统一样式 */
.left_dom_text,
.right_dom_text {
  padding: 1rem;
  line-height: 1.5;
  border-radius: 16px;
  width: 100%;
  margin: 1rem;
  font-size: 16px;
  color: #1a1a1a;
}

.right_dom_text {
  background: rgb(65, 105, 225);
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgb(65, 105, 225);
}

.left_dom_text {
  background: #eff6ff;
  color: #1a1a1a !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #bfdbfe;
  /* 知识库 */
  // .docs {
  //   width: 100%;
  //   // margin: 0 10px;
  //   > div {
  //     margin: 10px 0;
  //     background-color: #ffffff;
  //     padding: 10px;
  //     border-radius: 10px;
  //     color: #5e87e0;
  //     //  white-space: nowrap;
  //     // overflow: hidden;
  //     // text-overflow: ellipsis;
  //   }
  //   .more {
  //     text-decoration: underline;
  //   }
  //   .more:hover {
  //     cursor: pointer;
  //     color: rgb(65, 105, 225);
  //   }
  // }
}


/* 弹窗 */
.dialog {
  div {
    height: 300px;
    font-weight: 600;
    line-height: 20px;
    overflow-y: auto;
  }
}
</style>
